export function getLastYearRevenue(customer: customer): number {
    let lastYear = new Date().getFullYear() - 1

    // search latest year with revenue data
    while (lastYear >= 2000) {
        if (customer.revenue[lastYear.toString()]) {
            return customer.revenue[lastYear.toString()] || 0
        }
        lastYear--
    }

    return 0
}

export const sortCustomers = (list: customer[], sortValue: 'company_name' | 'revenue' | 'revenue_last_year') => {
    const currentYear = new Date().getFullYear()
    const lastYear = currentYear - 1

    // check if sortValue is valid
    if (!['company_name', 'revenue', 'revenue_last_year'].includes(sortValue)) {
        return list
    }

    const sortedCustomers = list.slice().sort((a, b) => {
        if (a.favorite !== b.favorite) {
            return a.favorite ? -1 : 1
        }
        if (sortValue === 'company_name') {
            return a.company_name.localeCompare(b.company_name)
        } else if (sortValue === 'revenue') {
            return (b.revenue[currentYear] || 0) - (a.revenue[currentYear] || 0)
        } else if (sortValue === 'revenue_last_year') {
            return (b.revenue[lastYear] || 0) - (a.revenue[lastYear] || 0)
        }
        return 0
    })

    return sortedCustomers
}

export function getHighlightedName(name: string, searchValue?: string): React.ReactNode {
    if (!searchValue) return name

    const highlightedName = name.split(new RegExp(`(${searchValue})`, 'gi')).map((part, index) =>
        part.toLowerCase() === searchValue.toLowerCase() ? (
            <span
                key={index}
                className='highlight'>
                {part}
            </span>
        ) : (
            part
        ),
    )

    return highlightedName
}
